// extracted by mini-css-extract-plugin
module.exports = {"Component":"AppPoint_Component__1xSW7"};